import { render, staticRenderFns } from "./InspectionDashBoard.vue?vue&type=template&id=03fafa24&scoped=true&"
import script from "./InspectionDashBoard.vue?vue&type=script&lang=js&"
export * from "./InspectionDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./InspectionDashBoard.vue?vue&type=style&index=0&id=03fafa24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fafa24",
  null
  
)

export default component.exports